import React, { useMemo, forwardRef } from 'react';
import '../css/school.css';

const PreySchool = forwardRef(function PreySchool({
  count = 5,
  schoolDuration = '10s',
  imgSrc = '/images/animals/0_5m/prey/neon_tetra_head.png',
  onFlee,
}, ref) {
  const fishes = useMemo(() => {
    const dur = parseFloat(schoolDuration);
    return Array.from({ length: count }).map((_, i) => ({
      delay: `${-(Math.random() * dur)}s`,
      left:  `${Math.random() * 80 + 10}%`,
    }));
  }, [count, schoolDuration]);

  return (
    <div ref={ref} className="school-container">
      {fishes.map((f, i) => (
        <img
          key={i}
          src={imgSrc}
          alt="Prey fish"
          className="prey-fish"
          style={{ animationDuration: schoolDuration, animationDelay: f.delay, left: f.left }}
          onMouseEnter={onFlee}
        />
      ))}
    </div>
  );
});

export default PreySchool;
